import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=8d5ee55a&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=js&"
export * from "./ShareButtons.vue?vue&type=script&lang=js&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=8d5ee55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ee55a",
  null
  
)

export default component.exports